<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="comments"/> ZBS
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tabIndex">
          <b-tab :disabled="!['owner','admin', 'tech' , 'operationsManager', 'account', 'am'].includes($store.state.user.role)">
            <template #title>
              {{ $t('znsTemplate') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('znsHistory') }}
            </template>
          </b-tab>
          <b-tab v-if="['owner','admin','tech'].includes($store.state.user.role)">
            <template #title>
              {{ $t('znsSupplier') }}
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <z-n-s-template-list v-if="tabIndex === 0"></z-n-s-template-list>
    <history v-if="tabIndex === 1"></history>
    <z-n-s-gateway v-if="tabIndex === 2"></z-n-s-gateway>
  </main>
</template>

<script>


import ZNSTemplateList from "@/views/zns/ZNSTemplateList.vue";
import History from "@/views/zns/History.vue";
import ZNSGateway from "@/views/zns/ZNSGateway.vue";

export default {
  components: {History, ZNSTemplateList, ZNSGateway},
  data() {
    return {
      tabIndex: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        znsHistory: 'ZBS history',
        znsTemplate: 'ZBS template',
        znsSupplier: 'ZBS Supplier',
      },
      vi: {
        znsHistory: 'Lịch sử ZBS',
        znsTemplate: 'Mẫu tin nhắn ZBS',
        znsSupplier: 'Nhà cung cấp ZBS',
      }
    }
  },
}
</script>